import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { walkClaimText } from '../../../../lib/walkClaimText';
import { PowerIntentIntroStrip } from './PowerIntentIntroStrip';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const GridRedundancySection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.powerAnalysis?.redundancyAssessment;
  return (
    <SectionShell label={label} hasData={!!text}>
      <PowerIntentIntroStrip report={report} focus="redundancy" />
      {text && (
        <EditorialSubsection theme={theme} label="Redundancy assessment">
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
